import React, { useContext, useEffect, useState } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextArea,
  InputTextMaster,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { TYPE_INSTANCE4 } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import { urlGetGudang } from "../../helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { isNull, today } from "App/utils/helpers";
import { SearchIcon } from "App/Assets";
import ModalListRequest from "../ModalListRequest";
export default function FormPo() {
  const { formData, setFormData, rowsSelect, setListPO, setRowsRekomendasi } =
    useContext(FormContext);
  const [showModalListRequest, setShowModalListRequest] = useState(false);

  const supplier = useInitialMasterSupplier(
    true,
    LIST_URL_WAREHOUSE.masterSuppilerLGS.get
  );

  const gudangUtama = useSelectOption(true, urlGetGudang, TYPE_INSTANCE4);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      date: moment(new Date()).local().toDate(),
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickSelect = async (row, rekomendasi) => {
    setFormData({
      ...formData,
      idreq: row?.id,
      idpo: "",
      date: today(),

      unit_id: row?.unit_id,
      unit: row?.unit,

      supplier_id: null,
      supplier: "Pilih Supplier",

      penerima: "",
      // remark: row?.remark,
      remark: "",
      nomorPo: "",

      type: "create",
      status: 0,

      isOpenDraf: false,
      isProcess: false,
      isRequest: true,

      jumlah: 0,
      tax: 0,
      total_jumlah: 0,
      listpo: [],
      status_transaksi: 0,
      catatan_proses: "",
    });
    setListPO([]);
    setRowsRekomendasi(rekomendasi);
    setShowModalListRequest(false);
  };

  return (
    <>
      {showModalListRequest && (
        <ModalListRequest
          setShowModal={() => setShowModalListRequest(false)}
          handleClickSelect={handleClickSelect}
          onlySelect={false}
        />
      )}
      <form action="">
        <Grid container spacing={1}>
          <Grid item sm={8}>
            <Grid container spacing={1}>
              <Grid item sm={4}>
                {isNull(formData.idpo) ? (
                  <InputTextMaster
                    name="id"
                    label="ID / ID REQUEST"
                    id="id"
                    placeholder={"Cari Request"}
                    disabled={true}
                    value={
                      formData?.isRequest
                        ? formData?.idreq +
                          " ( " +
                          rowsSelect.length +
                          " Barang Terpilih)"
                        : formData.idpo
                    }
                    withButton={true}
                  >
                    <button
                      type={"button"}
                      onClick={() =>
                        setShowModalListRequest(!showModalListRequest)
                      }
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                    </button>
                  </InputTextMaster>
                ) : (
                  <InputTextMaster
                    name="id"
                    label="ID Request / ID PO"
                    id="id"
                    value={
                      isNull(formData.idpo) ? formData.idreq : formData.idpo
                    }
                    placeholder={"-"}
                    disabled={true}
                    withButton={false}
                  />
                )}{" "}
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="id"
                  label="NO. PURCHASE ORDER"
                  id="id"
                  placeholder="-"
                  disabled={true}
                  value={formData.nomorPo}
                />
              </Grid>
              <Grid item sm={4}>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label htmlFor="date" className="form-control-label">
                    TANGGAL
                  </label>

                  <div
                    onClick={() =>
                      setFormData({
                        ...formData,
                        date: moment(new Date()).local().toDate(),
                      })
                    }
                    style={{
                      fontSize: "10px",
                      color: "#3399ff",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </div>
                </div>
                <DatePicker
                  id="date"
                  autoComplete="off"
                  className="form-control text"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  disabled={formData.isProcess}
                  locale="id-ID"
                  selected={moment(formData.date).toDate()}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      date: e,
                    });
                  }}
                  placeholderText="Tanggal"
                />
                {/* <InputTextMaster
                name='date'
                label='TANGGAL'
                id='date'
                disabled={formData.isProcess}
                value={formData.date}
                onChange={handleChange("date")}
                placeholder='Tanggal'
                type={"datetime-local"}
              /> */}
              </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="gudang_id"
                  label="GUDANG UTAMA LOGISTIK"
                  id="gudang_id"
                  withSearch={true}
                  disabled={formData.isProcess}
                  data={gudangUtama}
                  value={formData.gudang_id}
                  labelValue={formData.gudang}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "gudang_id", "gudang")
                  }
                />
              </Grid>

              <Grid item sm={4}>
                <InputOptionMaster
                  name="supplier_id"
                  label="SUPPLIER"
                  id="supplier_id"
                  withSearch={true}
                  disabled={formData.isProcess}
                  data={supplier}
                  value={formData.supplier_id}
                  labelValue={formData.supplier}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "supplier_id", "supplier")
                  }
                />
              </Grid>

              <Grid item sm={4}>
                <InputTextMaster
                  name="penerima"
                  label="PENERIMA"
                  disabled={formData.isProcess}
                  id="penerima"
                  placeholder="Penerima"
                  value={formData.penerima}
                  onChange={handleChange("penerima")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={4}>
            <InputTextArea
              name="remark"
              label="CATATAN SURAT PURCASE ORDER"
              id="remark"
              disabled={formData.isProcess}
              placeholder="Catatan"
              rows={5}
              value={formData.remark}
              onChange={handleChange("remark")}
            />
          </Grid>
        </Grid>
      </form>
    </>
  );
}
